import { GET_PROPERTIES_PATH } from 'src/services/api/properties/constants';

export const touringHoursPath = (propertyId: number) =>
    `${GET_PROPERTIES_PATH}/${propertyId}/touring-hours`;
